module.exports = {
  templateUrl: 'profile/components/profile-management/profile-management.html',
  controller: class ProfileManagement {

    static $inject =[
      '$ngRedux',
      '$scope',
      '$state',
      '$translate',
      'PatientAppContextService',
      'ProductService',
    ];

    constructor(
      $ngRedux,
      $scope,
      $state,
      $translate,
      PatientAppContextService,
      ProductService,
    ) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
      this.$translate = $translate;
      this.PatientAppContextService = PatientAppContextService;
      this.ProductService = ProductService;

      this.context = this.PatientAppContextService.context;
      this.group = this.context.group;
      this.patient = this.context.patient;
      this.authenticatedPatient = this.context.authenticatedPatient;
    }

    $onInit() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        isHospitalBooking: state.hospitalBooking.isHospitalBooking,
      }))(this));

      this.hasNotificationsTab = !!this.PatientAppContextService.context.authenticatedPatient.subscription.account &&
        !this.authenticatedPatient.subscription.preventBooking;
      this.hasRemindersTab = this.ProductService.isAvailable('PATIENT_NOTIFICATION_PREFERENCE') &&
        (this.ProductService.isAvailable('PATIENT_PHONE_REMINDERS') ||
        this.ProductService.isAvailable('PATIENT_SMS_REMINDERS'));

      this.hasActiveTab = false;
      this.setActiveTab(null, this.$state.current);
      this.$scope.$on('$stateChangeSuccess', this.setActiveTab);
    }

    setActiveTab = (event, toState, toParams, fromState) => {
      this.nextTab = _.last(toState.name.split('.'));

      if (toState.parent === 'patients.id.update') {
        this.activeTab = this.nextTab;
      }

      if (!fromState || fromState.name !== 'patients.id.home') {
        this.hideMenu();
      }
    }

    showMenu = () => {
      this.hasActiveTab = false;
    }

    hideMenu = () => {
      this.hasActiveTab = true;
    }

    changeTab = (state) => {
      if (state === this.$state.current.name) {
        this.hideMenu();
      } else {
        this.$state.go(state);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./profile/components/profile-management/profile-management.js